import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { translate } from '../../Services/translation';
import { breakpoint } from '../../styling/mixins/breakpoints';
import BlockArea from '../Checkout/Checkout.BlockArea';
import { useLocation } from 'react-router-dom';

const StyledMyPagesFrontPage = styled.div`
  grid-column: span 2;
  h1 {
    margin-bottom: 1.6rem;
    ${breakpoint('large')} {
      margin-bottom: 2.4rem;
    }
  }
  .section {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

const MyPagesFrontPage = ({ blockContent }) => {
  return (
    <StyledMyPagesFrontPage>
      <h1 className="title">{translate('mypage.frontpage.title')}</h1>
      {blockContent && <BlockArea blocks={blockContent} />}
    </StyledMyPagesFrontPage>
  );
};

export default MyPagesFrontPage;
